import { render } from "./TheArticle.vue?vue&type=template&id=1249dfac"
import script from "./TheArticle.vue?vue&type=script&lang=js"
export * from "./TheArticle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__